module.exports = __webpack_public_path__ + "static/img/icon-section-02.5d5c898f.png";